import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/unit-sell-bys/profile/loading';

export const Route = createFileRoute('/_private/settings/unit-sell-bys/$id')({
  pendingComponent: Loading,
});
